import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { baseUrl, userLocation, ipAddress, userName } from "../Univ.js";

function RFIDTagPage() {

  const [rows, setRows] = useState([]);
  const [products, setProducts] = useState([]);

  const [data, setData] = useState({
    tag_uid: "",
    product: "",
    is_active: true
  });

  useEffect(() => {
    fetchData();
    fetchProducts();
  }, []);

  const fetchData = () => {
    axios.get(baseUrl + "rfid-tags/")
      .then(res => setRows(res.data));
  };

  const fetchProducts = () => {
    axios.get(baseUrl + "products/")
      .then(res => setProducts(res.data));
  };

  const inputHandler = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const formSubmit = () => {

    if (!data.tag_uid || !data.product) {
      Swal.fire("Error", "Tag UID and Product required", "error");
      return;
    }

    const _formData = new FormData();
    _formData.append("tag_uid", data.tag_uid);
    _formData.append("product", data.product);
    _formData.append("is_active", data.is_active);
    _formData.append("status", "1");
    _formData.append("addedby", userName);
    _formData.append("ip_add", ipAddress);
    _formData.append("location", userLocation);

    axios.post(baseUrl + "rfid-tags/", _formData)
      .then(() => {
        Swal.fire("Created", "RFID Tag Added", "success");
        setData({ tag_uid: "", product: "", is_active: true });
        fetchData();
      })
      .catch(() => {
        Swal.fire("Error", "Tag UID must be unique", "error");
      });
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Confirm Delete?",
      icon: "warning",
      showCancelButton: true
    }).then(result => {
      if (result.isConfirmed) {
        axios.delete(baseUrl + "rfid-tags/" + id + "/")
          .then(() => {
            Swal.fire("Deleted", "", "success");
            fetchData();
          });
      }
    });
  };

  const columns = [
    { field: "id", headerName: "ID", width: 80 },
    { field: "tag_uid", headerName: "Tag UID", flex: 1 },
    {
      field: "product",
      headerName: "Product",
      flex: 1,
      renderCell: (params) => params.row.product?.name || "Unknown"
    },
    { field: "is_active", headerName: "Active", width: 120 },
    { field: "add_date", headerName: "Date", width: 120 },
    {
      field: "edit",
      headerName: "Edit",
      renderCell: (params) => (
        <Link to={`/rfid/edit/${params.row.id}`} target="_blank" className="btn btn-warning btn-sm">
          Edit
        </Link>
      ),
      width: 120
    },
    {
      field: "delete",
      headerName: "Delete",
      renderCell: (params) => (
        <button onClick={() => handleDelete(params.row.id)} className="btn btn-danger btn-sm">
          Delete
        </button>
      ),
      width: 120
    }
  ];

  return (
    <div className="container mt-4">

      <div className="card p-4 mb-4">
        <h4>Add RFID Tag</h4>

        <input
          className="form-control mt-3"
          placeholder="Tag UID"
          name="tag_uid"
          value={data.tag_uid}
          onChange={inputHandler}
        />

        <select
          className="form-control mt-3"
          name="product"
          value={data.product}
          onChange={inputHandler}
        >
          <option value="">Select Product</option>
          {products.map(p => (
            <option key={p.id} value={p.id}>{p.name}</option>
          ))}
        </select>

        <button className="btn btn-success mt-3" onClick={formSubmit}>
          Submit
        </button>
      </div>

      <div className="card p-3">
        <DataGrid
          sx={{
            boxShadow: 4,
            border: 4,
            borderColor: "primary.light",
            "& .MuiDataGrid-cell:hover": { color: "primary.main" }
          }}
          rows={rows}
          columns={columns}
          pageSize={10}
          autoHeight
          components={{ Toolbar: GridToolbar }}
        />
      </div>

    </div>
  );
}

export default RFIDTagPage;
